<template>
  <div v-if="isLoaded">
    <form @submit.prevent="submitForm" novalidate class="mt-4">
      <div class="row mt-3">
        <div class="col-lg-8 col-md-12">
          <BaseInput v-model="formData.topic" label="Grund / Thema"/>
        </div>
        <div class="col-lg-12">
          <TextEditor
              v-model="formData.focusOfCare"
              @update:model-value="formData.focusOfCare = $event"
              :inputStyle="{ height: '200px' }"
              label="Betreuungsschwerpunkt"/>
        </div>
        <div class="col-lg-12 mt-4">
          <TextEditor
              v-model="formData.currentSituation"
              @update:model-value="formData.currentSituation = $event"
              :inputStyle="{ height: '200px' }"
              label="Aktuelle Situation"/>
        </div>
      </div>

      <div class="d-flex justify-content-center w-100 mt-4">
        <SaveButton
            :label="$t('general.button.save')"
            :loading="isSubmitting"/>
      </div>
    </form>
  </div>
</template>

<script setup>
import portalAssistedLivingCoachingService from '@/api/Portal/AssistedLivingCoaching';
import BaseInput from '@/components/base/BaseInput.vue';
import TextEditor from '@/components/TextEditor.vue';
import { ErrorToast, SuccessToast } from '@/components/VueToast';
import { defineEmits, defineProps, onMounted, ref, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';
import SaveButton from '@/components/button/SaveButton.vue';

const { t }        = useI18n();
const isLoaded     = ref(false);
const isSubmitting = ref(false);
const emit         = defineEmits([ 'update:modelValue', 'update:submitForm' ]);

const props = defineProps({
  coachingId: {
    type: Number,
    required: true,
  },
  interimReportId: {
    type: Number,
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const coachingId      = toRefs(props)[ 'coachingId' ];
const interimReportId = toRefs(props)[ 'interimReportId' ];

const formData = ref({
  coachingId: '',
  topic: '',
  focusOfCare: '',
  currentSituation: '',
});

async function submitForm() {
  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    formData.value.coachingId = +coachingId.value;

    if (props.interimReportId) {
      await portalAssistedLivingCoachingService.putInterimReport(formData.value, +interimReportId.value);
    } else {
      await portalAssistedLivingCoachingService.postInterimReport(formData.value);
    }

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getInterimReportData(interimReportId) {
  try {
    const { data } = await portalAssistedLivingCoachingService.getInterimReport(+interimReportId);
    formData.value = {
      ...data.data,
    };
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  if (interimReportId.value) {
    await getInterimReportData(+interimReportId.value);
  }

  isLoaded.value = true;
});
</script>
<style scoped>

</style>